<template lang="pug">
  div.award-levitated-sphere-container
    .award-levitated-sphere-coin(
      :class="awardInfo.className"
      @click="handleBubbleClick"
    )
      .award-coin-account(v-if="awardStatus !== 'NORMAL'") {{ rewardCount }}
    img.award-coin-past-due(
      v-if="awardStatus === AWARD_COIN_STATUS.PAST_DUE"
      src="https://m.hellobike.com/resource/gallery/833/WhYMN5B71F.png"
      alt=""
      @click="handleBubbleClick"
    )
    .award-levitated-sphere-title(@click="handleBubbleClick") App单单返

    //- 手指动画
    template(v-if="showFinger")
      Lottie.finger-lottie(
        url="https://m.hellobike.com/resource/helloyun/08345/DAcMKLrQ3U.json"
      )
</template>

<script>
import SPM from '../common/spm';
import { AWARD_COIN_STATUS, AWARD_COIN_STATUS_MAP } from '../consts';

export default {
  name: 'AwardLevitatedSphere',
  components: {
    Lottie: () => import('@/components/lottie'),
  },
  props: {
    // 单单返币奖励金数量
    rewardCount: {
      type: Number,
      default: 0,
    },
    // 单单返奖励金是否即将过期
    isDueSoon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AWARD_COIN_STATUS,
      // 手指动画是否显示
      showFinger: false,
      // 领取状态
      awardStatus: AWARD_COIN_STATUS.NORMAL,
      // 不同状态配置信息
      awardInfo: {},
    };
  },
  watch: {
    rewardCount: {
      handler() {
        let awardStatus = AWARD_COIN_STATUS.NORMAL;
        if (this.rewardCount) {
          awardStatus = this.isDueSoon
            ? AWARD_COIN_STATUS.PAST_DUE
            : AWARD_COIN_STATUS.AWARD;
          this.showFinger = true;
        }

        this.awardStatus = awardStatus;
        this.awardInfo = AWARD_COIN_STATUS_MAP[awardStatus];
      },
      immediate: true,
    },
  },
  mounted() {
    // 曝光悬浮球埋点
    const exposeModuleId = this.rewardCount ? 'bonus_toreceive' : 'ordertask_bonus';
    SPM.moduleExpose({
      moduleId: exposeModuleId,
      contentId: exposeModuleId,
      businessInfo: {},
    });
  },
  methods: {
    // 悬浮球点击
    handleBubbleClick() {
      this.showFinger = false;
      this.$emit('awardClick', this.awardStatus);

      // 点击悬浮球埋点
      const exposeModuleId = this.rewardCount ? 'bonus_toreceive' : 'ordertask_bonus';
      SPM.clickButton({
        buttonName: exposeModuleId,
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.award-levitated-sphere-container {
  position: relative;
  animation: float 2s ease-in-out infinite;

  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-0.05rem);
    }
  }

  .award-levitated-sphere-coin {
    overflow: hidden;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.51rem;
    height: 0.46rem;
    background-image: url('https://m.hellobike.com/resource/gallery/833/47Q4rxvS_Group%201707483334%20(1).png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    &.normal {
      background-image: url('https://m.hellobike.com/resource/gallery/833/47Q4rxvS_Group%201707483334%20(1).png');
    }

    &.award {
      background-image: url('https://m.hellobike.com/resource/gallery/833/_zy09H_k_Group%201707483331%20(1).png');
    }

    &.past-due {
      background-image: url('https://m.hellobike.com/resource/gallery/833/_zy09H_k_Group%201707483331%20(1).png');
    }

    &.shine-light::after {
      content: '';
      z-index: 99;
      position: absolute;
      display: inline-block;
      left: 0;
      top: 0;
      width: 0.15rem;
      height: 100%;
      opacity: 0.9;
      transform: skewX(150deg);
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3) 30%, transparent);
      animation: move-light 2s infinite;
    }

    @keyframes move-light {
      100% {
        left: 170%;
      }
    }

    .award-coin-account {
      font-family: 'DIN Alternate Bold', sans-serif;
      font-size: 0.13rem;
      line-height: normal;
      color: #996201;
      transform: translate(-0.01rem, 0.01rem);
      text-shadow: 0 0 0.01rem #fff, 0 0 0.01rem #fff, 0 0 0.01rem #fff,
        0 0 0.01rem #fff, 0 0 0.01rem #fff, 0 0 0.01rem #fff;
    }
  }

  .award-coin-past-due {
    position: absolute;
    top: 0.3rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0.38rem;
    height: 0.12rem;
  }

  .award-levitated-sphere-title {
    font-size: 0.1rem;
    line-height: 0.14rem;
    font-weight: 600;
    color: #fff;
  }

  .finger-lottie {
    position: absolute;
    top: 0.01rem;
    right: -0.36rem;
    z-index: -1;
    width: 1.6rem;
  }
}
</style>
